export enum ENUMS {
  ZEMG = "ZEMG",
  ZCHG = "ZCHG",
  IS_DINAMO = "X",
}
